import React from 'react';
import '../styles/theme.css';

export default function SectionLabel({ children }) {
  return (
    <p className="section-label">
      {children}
      <span />
    </p>
  );
}
